import React, { FC } from 'react';

import { ListCards } from '@/components/molecules/ListCards/render';

import block from './block.json';

/**
 * COMPONENT
 */
export const ListLogos: FC<ListCardsProps> & BlockConfigs = (props) => {
	return <ListCards {...props} />;
};

ListLogos.slug = block.slug;
ListLogos.title = block.title;
